export const styles = {
  modal: {
    borderRadius: "16px",
    maxWidth: "480px",
    padding: "24px 16px",
  },

  content: {
    alignItems: "center",
    textAlign: "center",
    padding: "0",
  },

  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    padding: 0,
    zIndex: 2,
    color: "#393939",

    ":hover": {
      border: "none",
    },
  },
};
